import useSWR from 'swr';

import type { ErrorWithMessage } from '../types/ErrorWithMessage';
import { createFetcher } from './request';

interface CountryResponse {
  country: string;
}

const fetcher = createFetcher<CountryResponse>(
  'https://europe-west1-trhub-prod.cloudfunctions.net',
);

const useGeoLocation = (disabled: boolean) => {
  const { data, error } = useSWR<CountryResponse, ErrorWithMessage>(
    disabled ? null : 'geolocation',
    fetcher,
  );
  const country = data != null ? data.country : undefined;
  const isLoading = !disabled && data == null && error == null;

  return [country, error, isLoading, disabled] as const;
};

export default useGeoLocation;
